import { render, staticRenderFns } from "./EditProgramForm.vue?vue&type=template&id=1acb6e9a"
import script from "./EditProgramForm.vue?vue&type=script&lang=js"
export * from "./EditProgramForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports